import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { FiBarChart2, FiUser, FiList, FiSearch, FiPlus } from 'react-icons/fi';
import { FaBell, FaChartLine, FaChartPie } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import api from '../../../services/api';
import logo from '../../../assests/logo-transparent.png';
import './styles.css';

function excerpt(text, max) {
  if (!text) return '';
  const plain = String(text).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  if (plain.length <= max) return plain;
  return `${plain.substring(0, max).trim()}…`;
}

export default function FeedLayout({ children, active = 'timeline' }) {
  const { t } = useTranslation();
  const history = useHistory();
  const name = sessionStorage.getItem('name') || '';
  const nickname = sessionStorage.getItem('nickname') || '';
  const USER_EMAIL = sessionStorage.getItem('email');
  const USER_TOKEN = sessionStorage.getItem('token');
  const [menuOpen, setMenuOpen] = useState(false);
  const [news, setNews] = useState([]);
  const [newsSlug, setNewsSlug] = useState('noticias');

  useEffect(() => {
    const headers = {
      USER_EMAIL,
      USER_TOKEN,
      'Content-Type': 'application/json',
    };

    api.get('/v4/tags', { headers }).then((response) => {
      const tags = response.data || [];
      sessionStorage.setItem('TAGS', JSON.stringify(tags));
      const found = tags.find((tag) => {
        const slug = String(tag.slug || '').toLowerCase();
        const nameTag = String(tag.name || '').toLowerCase();
        return slug.indexOf('noticia') !== -1 || nameTag.indexOf('noticia') !== -1;
      });
      const slug = found && found.slug ? found.slug : 'noticias';
      setNewsSlug(slug);
      return api.get(`/v6/posts?page=1&by_kind=feed&by_tag=${slug}`, { headers });
    }).then((response) => {
      setNews((response.data || []).slice(0, 8));
    }).catch(() => {
      setNews([]);
    });
  }, [USER_EMAIL, USER_TOKEN]);

  function irTimelineTodos(e) {
    sessionStorage.setItem('hashTag', '');
    sessionStorage.setItem('timelineClassificados', '');
    if (history.location.pathname === '/timeline') {
      e.preventDefault();
      history.push({ pathname: '/timeline', state: { view: 'todos', t: Date.now() } });
    }
  }

  function abrirNoticias() {
    sessionStorage.setItem('hashTag', newsSlug);
    sessionStorage.setItem('timelineClassificados', '');
    history.push(`/timeline/${newsSlug}`);
  }

  return (
    <div className="feed-layout">
      <aside className="feed-left">
        <Link className="feed-brand" to="/timeline" onClick={irTimelineTodos}>
          <img src={logo} alt="agrobrazil" />
        </Link>

        <div className="feed-nav">
          <Link className={active === 'timeline' ? 'is-active' : ''} to="/timeline" onClick={irTimelineTodos}>
            <FiList size={22} />
            <span>{t('pages.includes.header.timeline')}</span>
          </Link>
          <Link className={active === 'search' ? 'is-active' : ''} to="/timelinebusca">
            <FiSearch size={22} />
            <span>Buscar</span>
          </Link>
          <Link className={active === 'notifications' ? 'is-active' : ''} to="/notificacoes">
            <FaBell size={20} />
            <span>Notificações</span>
          </Link>
          <Link className={active === 'ranking' ? 'is-active' : ''} to="/ranking">
            <FiBarChart2 size={22} />
            <span>{t('pages.includes.header.ranking')}</span>
          </Link>
          <Link className={active === 'scales' ? 'is-active' : ''} to="/escalas">
            <FaChartLine size={20} />
            <span>{t('pages.includes.header.scales')}</span>
          </Link>
          <Link className={active === 'negotiations' ? 'is-active' : ''} to="/negociacoes">
            <FaChartPie size={20} />
            <span>{t('pages.includes.header.negotiations')}</span>
          </Link>
          <Link className={active === 'classifieds' ? 'is-active' : ''} to="/classificados">
            <FiList size={22} />
            <span>{t('pages.includes.filters.classified')}</span>
          </Link>
          <Link className={active === 'profile' ? 'is-active' : ''} to="/perfil">
            <FiUser size={22} />
            <span>{t('pages.includes.header.profile')}</span>
          </Link>
        </div>

        <div className="feed-create">
          <button type="button" className="feed-post-btn" onClick={() => setMenuOpen(!menuOpen)}>
            <FiPlus size={18} />
            Publicar
          </button>
          {menuOpen && (
            <div className="feed-create-menu">
              <Link to="/mensagem" onClick={() => setMenuOpen(false)}>
                {t('pages.includes.header.options.newMessage')}
              </Link>
              <Link to="/negocio/cadastrar" onClick={() => setMenuOpen(false)}>
                {t('pages.includes.header.options.newNegotiation')}
              </Link>
              <Link to="/anuncio" onClick={() => setMenuOpen(false)}>
                {t('pages.includes.header.options.newClassified')}
              </Link>
            </div>
          )}
        </div>

        <Link className="feed-user" to="/perfil">
          <div className="feed-av" />
          <div>
            <b>{name}</b>
            <small>{nickname ? `@${nickname}` : USER_EMAIL}</small>
          </div>
        </Link>
      </aside>

      <div className="feed-center">
        {children}
      </div>

      <aside className="feed-right">
        <div className="feed-box">
          <button type="button" className="feed-box-title" onClick={abrirNoticias}>
            #NOTÍCIAS
          </button>
          {news.length === 0 && <p className="feed-empty">Nenhuma notícia recente</p>}
          <div className="feed-news-list">
          {news.map((post) => {
            const thumb = post.image && (post.image.medium || post.image.original);
            return (
              <Link
                key={post.id}
                className="feed-news"
                to={`/post/${post.id}`}
                onClick={() => sessionStorage.setItem('sPostDetalhe', JSON.stringify(post))}
              >
                {thumb && <img src={thumb} alt="" />}
                <strong>{excerpt(post.title, 72)}</strong>
              </Link>
            );
          })}
          </div>
          {news.length > 0 && (
            <button type="button" className="feed-more" onClick={abrirNoticias}>
              Ver todas
            </button>
          )}
        </div>
      </aside>
    </div>
  );
}
